import React from 'react';
import { Activity, Folder, Settings, BookOpen, HelpCircle, User, LogOut, PanelLeftClose, PanelLeftOpen, Circle } from 'lucide-react';
const ACTIVE_PROJECTS = [{
  name: 'Denali',
  id: 1
}, {
  name: 'Diamond',
  id: 8
}, {
  name: 'Cascade',
  id: 4
}];
interface SidebarProps {
  collapsed: boolean;
  onToggleCollapse: () => void;
  onProjectSelect?: (id: number) => void;
  onHomeSelect?: () => void;
}
export function Sidebar({
  collapsed,
  onToggleCollapse,
  onProjectSelect,
  onHomeSelect
}: SidebarProps) {
  return <aside className={`bg-[#2b2b30] text-gray-300 flex flex-col h-full flex-shrink-0 transition-all duration-300 ease-in-out relative ${collapsed ? 'w-[52px]' : 'w-52'}`} data-id="element-683">
      {/* Header: Logo + Collapse */}
      <div className={`flex items-center justify-between border-b border-white/[0.06] ${collapsed ? 'px-2 py-3' : 'px-4 py-3'}`} data-id="element-684">
        <button onClick={onHomeSelect} className={`flex items-center text-white font-bold tracking-tight ${collapsed ? 'justify-center w-full text-sm' : 'text-base'}`} data-id="element-685">
          {collapsed ? 'A' : 'AltConvey'}
        </button>
        {!collapsed && <button onClick={onToggleCollapse} className="p-1 rounded text-gray-500 hover:text-gray-300 hover:bg-white/[0.06] transition-colors" title="Collapse sidebar" data-id="element-686">
            <PanelLeftClose className="w-3.5 h-3.5" data-id="element-687" />
          </button>}
      </div>

      {/* Main nav */}
      <div className={`flex-1 flex flex-col ${collapsed ? 'px-1.5 py-2' : 'px-2.5 py-3'}`} data-id="element-688">
        <nav className="space-y-0.5" data-id="element-689">
          <button onClick={onHomeSelect} className={`w-full flex items-center rounded transition-colors bg-white/[0.08] text-white font-medium ${collapsed ? 'px-0 py-2 justify-center' : 'px-2.5 py-2'}`} title="Projects" data-id="element-690">
            <Activity className={`w-3.5 h-3.5 ${collapsed ? '' : 'mr-2.5'}`} data-id="element-691" />
            {!collapsed && <span className="text-[13px]" data-id="element-692">Projects</span>}
          </button>

          {!collapsed && <div className="ml-6 pl-2.5 border-l border-gray-600/50 space-y-px py-1" data-id="element-693">
              {ACTIVE_PROJECTS.map(project => <button key={project.name} onClick={() => onProjectSelect?.(project.id)} className="w-full flex items-center px-2.5 py-1.5 rounded text-gray-400 hover:text-white hover:bg-white/[0.06] transition-colors text-left" data-id="element-694">
                  <Circle className="w-1.5 h-1.5 mr-2 fill-emerald-400 text-emerald-400 flex-shrink-0" data-id="element-695" />
                  <span className="text-[13px]" data-id="element-696">{project.name}</span>
                </button>)}
            </div>}

          <NavItem icon={<Folder className="w-3.5 h-3.5" data-id="element-698" />} label="Documents" collapsed={collapsed} data-id="element-697" />
        </nav>
      </div>

      {/* Bottom section */}
      <div className={`${collapsed ? 'px-1.5 pb-2' : 'px-2.5 pb-3'}`} data-id="element-699">
        <nav className="space-y-0.5 mb-2" data-id="element-700">
          <NavItem icon={<BookOpen className="w-3.5 h-3.5" data-id="element-702" />} label="How It Works" collapsed={collapsed} data-id="element-701" />
          <NavItem icon={<HelpCircle className="w-3.5 h-3.5" data-id="element-704" />} label="FAQ" collapsed={collapsed} data-id="element-703" />
        </nav>

        <div className="pt-2 border-t border-white/[0.06] space-y-0.5" data-id="element-705">
          <NavItem icon={<User className="w-3.5 h-3.5" data-id="element-707" />} label="Account" collapsed={collapsed} data-id="element-706" />
          <NavItem icon={<Settings className="w-3.5 h-3.5" data-id="element-709" />} label="Settings" collapsed={collapsed} data-id="element-708" />
          <NavItem icon={<LogOut className="w-3.5 h-3.5" data-id="element-711" />} label="Log Out" collapsed={collapsed} data-id="element-710" />
        </div>

        {/* Expand button when collapsed */}
        {collapsed && <button onClick={onToggleCollapse} className="w-full flex items-center justify-center mt-2 py-1.5 rounded text-gray-500 hover:text-gray-300 hover:bg-white/[0.06] transition-colors" title="Expand sidebar" data-id="element-712">
            <PanelLeftOpen className="w-3.5 h-3.5" data-id="element-713" />
          </button>}
      </div>
    </aside>;
}
function NavItem({
  icon,
  label,
  active = false,
  collapsed = false
}: {
  icon: React.ReactNode;
  label: string;
  active?: boolean;
  collapsed?: boolean;
}) {
  return <a href="#" title={collapsed ? label : undefined} className={`flex items-center rounded transition-colors ${collapsed ? 'px-0 py-2 justify-center' : 'px-2.5 py-2'} ${active ? 'bg-white/[0.08] text-white font-medium' : 'hover:bg-white/[0.06] hover:text-white text-gray-400'}`} data-id="element-714">
      <span className={collapsed ? '' : 'mr-2.5'} data-id="element-715">{icon}</span>
      {!collapsed && <span className="text-[13px]" data-id="element-716">{label}</span>}
    </a>;
}